import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { MasterDataService, Spec, FormItems } from 'src/app/services/api/masterdata/masterdata.service';
import { SpecObject } from 'src/app/models/master-data/spec-object';
import { Router } from '@angular/router';
import { FormItemObject } from 'src/app/models/master-data/form-item-object';

@Component({
  selector: 'app-new-master-data',
  templateUrl: './new-master-data.component.html',
  styleUrls: ['./new-master-data.component.scss']
})
export class NewMasterDataComponent implements OnInit {
  
  spec:Spec;
  formItems: FormItems[];
  form: FormGroup;
  formItemsDeleted: FormItems[] = [];

    tooltip = {
      submit: '',
      reset: '',
    };
  
  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private notificationsService: NotificationsService,
    private masterDataService:MasterDataService,
    private router: Router
  ) { }

    get typeForm(){
      return this.form.get('type');
    }
    get descForm(){
      return this.form.get('desc');
    }
    get formItemsForm(){
      return this.form.get('formItemsForm') as FormArray;
    }
  
  
    ngOnInit() {  
      this.initForm();
      this.initTooltips();
    }
  
    initForm(){
      this.form = this.formBuilder.group({
        type: ['', Validators.required],
        value: ['', Validators.required],
        desc: ['', Validators.required],
        formItemsForm: this.formBuilder.array([])
      });
      this.addFormItem();
    }    
  
    private initTooltips() {
      this.translate.get('DUMMY.key').subscribe((translated: string) => {
        this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
        this.tooltip.reset = this.translate.instant('TOOLTIPS.resetForm');
      });
    }
  
    clearForm() {
      this.form.reset();
      this.initForm();
    }
  
  
    public submitForm() {
      if (this.validateForm()) {
        const spec: Spec = new SpecObject();
        
        spec.type = this.form.get('type').value;
        spec.value = this.form.get('value').value;
        spec.description = this.form.get('desc').value;
        
        this.masterDataService.addSpec(spec).subscribe((createdSpec: Spec) => {
          this.notificationsService.showNotification(`El dato maestro se ha creado correctamente`, NotificationLevel.SUCCESS);
    
          const formItems: FormItems[] = [];
          for (let item of this.formItemsForm.controls) {
            const newItem: FormItems = new FormItemObject();
            newItem.hjid = item.get('hjid').value;
            newItem.value = item.get('value').value;
            newItem.description = item.get('desc').value;
            newItem.specId = createdSpec; 
    
            formItems.push(newItem);
          }
    
          let promises: Promise<any>[] = [];
          formItems.forEach(formItem => {
            promises.push(this.masterDataService.addFormItem(formItem).toPromise());
          });
    
          Promise.all(promises).then(() => {
            this.goToSearchMasterData();
          }).catch(error => {
            this.notificationsService.showNotification(`Ha habido un problema al añadir los elementos del formulario:\n${error.error.errorDesc.stackTrace}`, NotificationLevel.ERROR);
          });
    
        }, (error) => {
          this.notificationsService.showNotification(
            `Ha habido un problema al crear el dato maestro ${spec.type} :\n${error.error.errorDesc.stackTrace}`, NotificationLevel.ERROR);
        });
      }
    }    
  
    validateForm(): boolean {
      if (!this.form.get("desc").value) {
        this.notificationsService.showNotification('Por favor, complete los campos del tipo de dato maestro.', NotificationLevel.WARNING);
        return false; 
      }
  
      for(let item of this.formItemsForm.controls){
        if(!item.get("value").value ||!item.get("desc").value){
          this.notificationsService.showNotification(`Por favor, complete todos los campos.`, NotificationLevel.WARNING);
          return false;
        }
      }
      return true;   
    }
  
    addFormItem(){
      const formItemFormGroup  = this.formBuilder.group({
        hjid: '',
        value: '',
        desc: ''
      });
      this.formItemsForm.push(formItemFormGroup);
    }
  
    removeFormItem(indice: number) {
      this.formItemsForm.removeAt(indice);
    }
  
    goToSearchMasterData():void{
      this.router.navigate(["/provision/management/master-data"]);
    }
  
    addFormItemWithValues(hjid: string, value: string, description: string){
      const formItemFormGroup  = this.formBuilder.group({
        hjid: hjid,
        value: this.formBuilder.control({value:value,disabled: false},Validators.required),
        desc: this.formBuilder.control({value:description,disabled: false},Validators.required)
      });
      this.formItemsForm.push(formItemFormGroup);
    }
  }
  